module.exports = {"220103001":"新发街道","220103002":"站前街道","220103003":"南广街道","220103004":"东广街道","220103005":"群英街道","220103006":"兴业街道","220103007":"凯旋街道","220103008":"团山街道","220103009":"柳影街道","220103010":"欣园街道","220103011":"长德街道","220103100":"兰家镇","220103101":"米沙子镇","220103102":"万宝镇","220103171":"合隆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220103.json
// module id = 692
// module chunks = 0